<template lang="pug">
	.proposal-list
		h2.content-block {{$tCaption('Proposals')}}
		ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(itemData) => itemData.total", :getItems="(itemData) => itemData.items", :getData="loadProposals", :columns="columns")
			template(v-slot:listing-cell-template="{ data }")
				a(@click="editProposal(data)")
					i.fas.fa-pen-square
		.add-button
			DxButton(icon="plus", type="default", @click="addNewRow")
</template>

<script>
import Data from 'app-core/Data';
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';

export default {
	translationCategory: 'proposal.List',
	components: { ListView, DxButton },
	data() {
		return {
			columns: [
				{ dataField: 'name', caption: this.$tCaption('Proposal'), serverField: 'Name' },
				{ dataField: 'opportunityOwner', caption: this.$tCaption('Opportunity owner'), serverField: 'OpportunityOwner' },
				{ dataField: 'advertiserName', caption: this.$tCaption('Advertiser name'), serverField: 'Advertiser' },
				{ dataField: 'advertiserIndustry', caption: this.$tCaption('Advertiser industry'), serverField: 'Advertiser' },
				{ dataField: 'presentationDate', caption: this.$tCaption('Presentation date'), dataType: 'date', serverField: 'PresentationDate', sortIndex: 0, sortOrder: 'desc' },
				{ dataField: 'author', caption: this.$tCaption('Author'), serverField: 'Author' },
				{ dataField: 'name', caption: ' ', cellTemplate: 'listing-cell-template', serverField: 'Name'  },
			]
		};
	},
	methods: {
		loadProposals(pageIndex, size, sortings) {
			return Data.getProposals(pageIndex, size, sortings).then(r => {
				if (__DEBUG__)
					console.debug('Proposals loaded', { r });
				return r;
			});
		},
		addNewRow(){
			this.$router.push({
				path: '/proposal/Builder'
			});
		},
		editProposal(data) {
			if (__DEBUG__)
				console.debug('Edit proposal', data);
			this.$router.push({ name: 'proposal-builder', params: { proposalData: data } });
		}
	}
};
</script>
<style lang="scss">
	.proposal-list {
		position: relative;

		.add-button {
			position: fixed;
			display: flex;
			align-items: center;
			justify-content: center;
			bottom: 40px;
			right: 40px;
			border-radius: 100px;
			width: 40px;
			height: 40px;
		}
	}
</style>
